import type { TAggregationInterval } from '@semios/app-platform-value-type-definitions'
import { hourThresholdForAggregations } from '@semios/app-platform-values-helpers-and-types'
import moment from 'moment-timezone'
import { detailsPanelStore } from 'stores/detailsPanelStore/detailsPanelStore'
import { userDetailsStore } from 'stores/userDetailsStore/userDetailsStore'

/**
 * TODO: choosing an aggregation interval dynamically
 * should ultimately be up to the API, but we can
 * work around it on the front-end for now via this
 */
export const chooseAmongstUnAggHourlyAndDaily = ({
  excludeFuture = false,
}: {
  excludeFuture?: boolean
} = {}): TAggregationInterval => {
  const { dateFrom, dateTo } = detailsPanelStore.getState()
  const from = moment.tz(dateFrom, 'utc')
  const to = moment.tz(dateTo, 'utc')
  // the values API caps against the UTC clock, so match it or it downgrades what we ask for
  const end = excludeFuture ? moment.min(to, moment.tz('utc')) : to
  const difference = end.diff(from, 'hours')
  const isFreeUser = userDetailsStore.getState().isFreeRegionalUser

  // 3 days should always be covered
  if (difference < hourThresholdForAggregations.UNAGGREGATED && !isFreeUser) return 'UNAGGREGATED'

  // 31 days should always be covered
  if (difference < hourThresholdForAggregations.HOURLY) return 'HOURLY'

  return 'DAILY'
}
